<script lang="ts">
  import { app } from './appState.svelte';
  import { COVERS, coverStyle } from './covers';
  import type { PageKind, TemplateId } from '../store/types';
  import { TEMPLATES, templatesForKind } from '../theme/templates';

  let { onclose, oncreated }: { onclose: () => void; oncreated: () => void } = $props();

  let title = $state('New Notebook');
  let cover = $state(0);
  let kind = $state<PageKind>('fixed');
  let template = $state<TemplateId>('lined');
  let creating = $state(false);

  const templates = $derived(templatesForKind(kind));
  $effect(() => { if (!templates.includes(template)) template = templates[0]!; });

  async function create() {
    if (creating) return;
    creating = true;
    try {
      await app.repo!.createNotebook({ title: title.trim() || 'Untitled', cover, defaultTemplate: template, defaultKind: kind });
      oncreated();
      onclose();
    } finally {
      creating = false;
    }
  }
</script>

<div class="backdrop" onclick={onclose} role="presentation">
  <div class="modal" onclick={(e) => e.stopPropagation()} role="dialog" aria-label="New notebook">
    <h2>New notebook</h2>
    <label>Title <input bind:value={title} /></label>
    <div class="row">
      <span>Cover</span>
      <div class="covers">
        {#each COVERS as _, i}
          <button class="swatch" class:active={cover === i} style="background:{coverStyle(i)}" onclick={() => (cover = i)} aria-label="Cover {i + 1}"></button>
        {/each}
      </div>
    </div>
    <div class="row">
      <span>Pages</span>
      <button class:active={kind === 'fixed'} onclick={() => (kind = 'fixed')}>Fixed (A4)</button>
      <button class:active={kind === 'infinite'} onclick={() => (kind = 'infinite')}>Infinite canvas</button>
    </div>
    <div class="row">
      <span>Paper</span>
      {#each templates as t}
        <button class:active={template === t} onclick={() => (template = t)}>{TEMPLATES[t].label}</button>
      {/each}
    </div>
    <div class="footer">
      <button onclick={onclose}>Cancel</button>
      <button class="primary" disabled={creating} onclick={create}>Create</button>
    </div>
  </div>
</div>

<style>
  .backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.3); display: grid; place-items: center; z-index: 50; }
  .modal { background: var(--surface); border-radius: var(--radius-modal); padding: 24px; width: min(440px, 92vw); box-shadow: var(--shadow-soft); display: flex; flex-direction: column; gap: 14px; }
  label { display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
  input { padding: 10px; border-radius: var(--radius-panel); border: 1px solid var(--hairline); background: var(--paper); color: var(--ink-primary); font: inherit; }
  .row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 13px; }
  .row > span { min-width: 52px; opacity: 0.7; }
  button { border: 1px solid var(--hairline); background: var(--paper); color: var(--ink-primary); border-radius: var(--radius-panel); padding: 8px 12px; min-height: 40px; cursor: pointer; }
  button.active { border-color: var(--accent); box-shadow: 0 0 0 1px var(--accent); }
  .swatch { width: 32px; height: 32px; min-height: 32px; padding: 0; border-radius: 8px; }
  .footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 6px; }
  .primary { background: var(--accent); color: #fff; border: none; }
  .primary:disabled { opacity: 0.5; cursor: default; }
</style>
